module.exports = __webpack_public_path__ + "36d9a271.svg";